<ng-content></ng-content>
<ng-template ngFor let-area [ngForOf]="displayedPanels" let-index="index" let-last="last">
    <tam-splitter-bar *ngIf="last === false" [direction]="direction" [order]="index*2+1" [width]="splitterBarWidth"
        (mousedown)="startDragging($event, index*2+1, index+1)"></tam-splitter-bar>
</ng-template>